import { styled } from 'styled-components';
import Row from 'react-bootstrap/Row';

const EmojiWrapper = styled(Row)`
  height: 10rem;

  .emoji {
    font-size: 7rem;
  }
`;

export { EmojiWrapper };
